import React, { useContext, useState } from 'react';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';

const CopyLinkButton = () => {
  const locId = useContext(LocaleContext);
  const [isCopied, setIsCopied] = useState(false);
  function copyUrl() {
    navigator.clipboard.writeText(
      getText(locId, 'Results', 'copiedUrl', 'shareQuizCta')
    );
    setIsCopied(true);
  }

  function copyTextHandler(textCopied) {
    return textCopied
      ? getText(locId, 'Results', 'linkCopiedSuccessfully', 'shareQuizCta')
      : getText(locId, 'Results', 'copyLinkButton', 'shareQuizCta');
  }
  return (
    <button
      className="button button--reversed-secondary"
      type="button"
      onClick={copyUrl}
      data-testid="copyLink_btn"
    >
      <img
        src="/public/icons/link-icon.png"
        alt=""
        role="presentation"
        className="copy-icon"
      />
      {copyTextHandler(isCopied)}
    </button>
  );
};

export default CopyLinkButton;
